"use client"
import Image from "next/image"
import { getThemeClass, getSectionPaddingClass } from "~/styles/styles"
import { TEAM_DATA } from "~/content/team"
import Section from "../../common/section"
import { useKeenSlider } from "keen-slider/react"
import "keen-slider/keen-slider.min.css"
import { useState } from "react"
import { ArrowRightCircleIcon, ArrowLeftCircleIcon } from "@heroicons/react/20/solid"

const TeamInfo = () => {
  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
    // loop: true,
    mode: "free-snap",
    slides: { perView: 2, spacing: 15 },
    breakpoints: {
      "(min-width: 512px)": {
        slides: { perView: 3, spacing: 15 },
      },
      "(min-width: 768px)": {
        slides: { perView: 4, spacing: 15 },
      },
    },

    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel)
    },
    created() {
      setLoaded(true)
    },
  })

  const [loaded, setLoaded] = useState(false)
  const [currentSlide, setCurrentSlide] = useState(0)

  return (
    <>
      <Section id="the-team" className={`${getThemeClass("light")} ${getSectionPaddingClass("default")}`}>
        <div className="mx-auto max-w-7xl">
          <h2 className={`mb-4 text-2xl font-bold leading-8 text-purpleblue md:text-[1.35rem] lg:text-2xl`}>The Team</h2>
          <div className={`flex gap-6 text-black`}>
            <div ref={sliderRef} className="keen-slider">
              {TEAM_DATA.map((people, i) => (
                <div key={people.name + i} className={`keen-slider__slide number-slide${i + 1}`}>
                  <Image
                    src={people.src}
                    alt={people.name}
                    width={1020}
                    height={1000}
                    placeholder="blur"
                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN8/+F9PQAJpAN42gzKSQAAAABJRU5ErkJggg=="
                    className={`w-full aspect-[1.02/1] border-[5px] rounded-3xl ${i % 2 === 0 ? "border-purpleblue" : "border-green"}`}
                  />
                  <div className="mt-3 pl-3 text-sm leading-4 lg:mt-5 lg:text-base lg:leading-5 ">
                    <strong>{people.name}</strong>
                    <p>{people.position}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="mt-4 flex">
            {loaded && instanceRef.current && (
              <>
                <ArrowLeftCircleIcon
                  onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => instanceRef.current?.prev() || e.stopPropagation()}
                  className={`size-8 cursor-pointer md:hidden ${currentSlide === 0 ? "pointer-events-none fill-gradient-blue3/0" : "fill-gradient-blue3"} `}
                />
                <ArrowRightCircleIcon
                  onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => instanceRef.current?.next() || e.stopPropagation()}
                  className={`ml-auto size-8 cursor-pointer md:hidden ${
                    currentSlide === instanceRef.current.track.details.slides.length - 1 ? "pointer-events-none fill-gradient-blue3/20" : "fill-gradient-blue3"
                  }`}
                />
              </>
            )}
          </div>
        </div>
      </Section>
    </>
  )
}

export default TeamInfo
